import React, { Component } from "react";
import {
  QueryResult,
  Searchbar,
  SearchInput,
  GrantsSearchContainer,
  HiddenFrequency,
  GrantSearchLabel,
  Blocks,
  SeachImage
} from "./style";
import { Icon } from "antd";
import MultiSelect from "./Select";
import TimeFrameComponent from "../DateTimepicker/TimeFrameComponent";
import { GrantDisplayFlex } from "../../style";
import { UnderLButton } from "../ContentComponent/style";
import { DisplayFlex } from "../../../../../../CommonComponents/commonStyles";
import SearchIcon from "../../../../../../assets/icons/search-icon.svg";
import { recordError } from "../../../../../../utils/commonUtil";
import  PropTypes from 'prop-types';

const Search = SearchInput;

class GrantSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: null,
      _search: [],
      dates: null,
      status: null,
      frequency: null,
      cleared: false,
      visible: false,
      selected: [],
      options: []
    };
    this.handleDropper = this.handleDropper.bind(this);
    this.handleFrequency = this.handleFrequency.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.dateValues = this.dateValues.bind(this);
    this.clearedFunc = this.clearedFunc.bind(this);
    this.child = React.createRef();
  }

  handleSearch = e => {
    try {
      if (e) {
        let search = e.target.value;
        search = search.replace(/\s\s+/g, " ");
        this.setState({ search, _search: search }, () =>
          this.props.handleSearch(this.state)
        );
      } else this.props.handleSearch(this.state);
    } catch (error) {
      recordError(error);
    }
  };

  searched = e => {
    this.setState({ search: e.target.value });
  };

  clearTime() {
    this.child.current.clearDates();
  }

  dateValues = (dates,type) => {
    this.setState({ dates }, () => this.props.handleSearch(this.state,type));
  };

  handleDropper = (status, type) => {
    this.setState({ status }, () => this.props.handleSearch(this.state,type));
  };

  handleFrequency = frequency => {
    this.setState({ frequency }, () => this.props.handleSearch(this.state));
  };

  clearedFunc(cleared) {
    this.setState({ cleared });
  }

  handleCancel = e => {
    this.setState({ visible: false });
  };

  startDateFunc = date => {
    this.setState({ filterMinDate: date });
  };

  endDateFunc = date => {
    this.setState({ filterMaxDate: date });
  };

  renderTimeFrame() {
    return (
      <TimeFrameComponent
        dateValues={(e) => this.dateValues(e,'timeframe')}
        cleared={this.state.cleared}
        dates={this.state.dates}
        tab={this.props.tab}
        tabKey={this.props.tabKey}
        clearedFunc={this.clearedFunc}
      >
        Select TimeFrame
      </TimeFrameComponent>
    );
  }

  render() {
    const { tab, options } = this.props;
    return (
      <>
        {options && options.status && (
          <GrantsSearchContainer role="form" aria-expanded="false" data-test = "txtGrantSearch">
            <Searchbar >
              <GrantDisplayFlex>
                <GrantSearchLabel first>Status</GrantSearchLabel>
                  <MultiSelect                    
                    options={options.status}
                    handleDropper={(e) => this.handleDropper(e,'status')}
                    cleared={this.state.cleared}
                    clearedFunc={this.clearedFunc}
                    placeholder="-Select-"
                    id={"statusSelect"}
                  />
                <GrantSearchLabel>Timeframe</GrantSearchLabel>
                {this.renderTimeFrame()}
                {options.frequency && options.frequency.length ? (
                  <DisplayFlex>
                    <GrantSearchLabel>Frequency</GrantSearchLabel>
                    <MultiSelect
                      options={options.frequency}
                      handleDropper={this.handleFrequency}
                      placeholder="-Select-"
                      cleared={this.state.cleared}
                      clearedFunc={this.clearedFunc}
                      id={`frequencySelect`}
                    />
                  </DisplayFlex>
                ) : (
                  <HiddenFrequency>
                    <MultiSelect id="hiddenSelect"/>
                  </HiddenFrequency>
                )}

                {!options.frequency && (
                  <UnderLButton
                    id="anrClearAll"
                    onClick={() => {
                      this.setState(
                        {
                          search: null,
                          _search: [],
                          dates: null,
                          status: null,
                          frequency: null,
                          cleared: true
                        },
                        () => this.props.handleSearch(this.state)
                      );
                    }}
                  >
                    Clear All
                  </UnderLButton>
                )}
              </GrantDisplayFlex>
              <SearchInput
                id="txtGrantSearch"
                placeholder="Search by charity"
                aria-label="Grant Search"
                suffix={
                  <SeachImage
                    id="imgGrantSearch"
                    src={SearchIcon}
                    alt="search_icon"
                    onClick={() => this.handleSearch()}
                  />
                }
                onPressEnter={e => this.handleSearch(e)}
                onChange={e => this.searched(e)}
                value={this.state.search}
                style={{ width: 200 }}
              />
            </Searchbar>
            {options.frequency && (
              <>
                <UnderLButton
                  id="anrClearAll"
                  onClick={() => {
                    this.setState(
                      {
                        search: null,
                        _search: [],
                        dates: null,
                        status: null,
                        frequency: null,
                        cleared: true
                      },
                      () => this.props.handleSearch(this.state)
                    );
                    this.setState({ cleared: true }, () => {});
                  }}
                >
                  Clear All
                </UnderLButton>
                <Blocks h={20} />
              </>
            )}
            {this.state._search.length > 0 && (
              <QueryResult>
                Showing Results for “{this.state._search}”
              </QueryResult>
            )}
          </GrantsSearchContainer>
        )}
      </>
    );
  }
}

GrantSearch.propTypes = {
  handleSearch: PropTypes.func,
}

export default GrantSearch;
